import { withRouter } from 'react-router';
import { compose } from 'redux';
import Routing from './Routing';
import withUserInfo from '../../containers/apollo/withUserInfo';
import withUserAccount from '../../containers/apollo/withUserAccount';
import withAnalytics from '../../containers/redux/withAnalytics';
import { withExperimentContext } from '../../contexts/Experiment';

const ExploreRouting = compose(
  withRouter,
  withUserInfo,
  withUserAccount,
  withAnalytics,
  withExperimentContext
)(Routing);

ExploreRouting.displayName = Routing.displayName;
export default ExploreRouting;
